export default "__VITE_ASSET__34d7899d__"